import { FormValues, getValue, InputFormGroup } from "o4a-react";
import * as React from "react";
import * as Messages from "../../codegen/Messages";
import { Fields as TagDetailsFields, TagsEditPanel } from "../../components/TagsEditPanel/TagsEditPanel";
import { useOperation } from "../../hooks/useOperation";
import { OperationActionProps } from "../OperationTypes";
import { MysqlBackupUpdateTagsProps, newMysqlBackupUpdateTags } from "./MysqlBackupUpdateTags";

export interface MysqlBackupEditTagsProps extends OperationActionProps {
  backupId: string | undefined;
  defaultTags?: { name: string; value: string; }[];
}

const MysqlBackupEditTags = (
  { targetId, location, backupId, defaultTags, onExecute, onCancel }: MysqlBackupEditTagsProps,
): JSX.Element => {
  const { trigger: triggerUpdateBackupTags } = useOperation<MysqlBackupUpdateTagsProps>(newMysqlBackupUpdateTags);

  return (
    <TagsEditPanel
      targetId={targetId}
      title={Messages.labels.editTags()}
      tagsDefaultValue={defaultTags || []}
      onSubmit={(formValues: FormValues) => {
        const tags: { name: string; value: string; }[] = getValue(formValues, TagDetailsFields.Tags, InputFormGroup);
        triggerUpdateBackupTags({
          backupId,
          tags,
          location,
          onExecute,
        });
      }}
      onClose={onCancel}
    />
  );
};

export const newMysqlBackupEditTags = (
  props: MysqlBackupEditTagsProps,
): JSX.Element => (<MysqlBackupEditTags {...props} />);
